export const counterStyles = ['progressBar', 'harveyBall'] as const

export type CounterStyle = (typeof counterStyles)[number]
